import { getEnvironmentConfig } from '../util/domainDetection';

// Update this URL when the usage guidelines document location changes
export const USAGE_GUIDELINES_URL = 'https://pepsico.sharepoint.com/:b:/r/teams/DevXTeam/Shared%20Documents/GPT%20Docs/usage-guidelines/devxgpt-user-guide.pdf?csf=1&web=1&e=eAPZNw';

export function getDevXHomeUrl(): string {
  return getEnvironmentConfig().devxHomeUrl;
}

export interface BuildFullExperienceUrlParams {
  view: 'chat' | 'assistants' | 'history';
  conversationId?: string;
  threadId?: string;
  assistantId?: string;
}

export function buildFullExperienceUrl(params: BuildFullExperienceUrlParams): string {
  const baseUrl = getDevXHomeUrl();
  const searchParams = new URLSearchParams();
  
  searchParams.set('view', params.view);
  
  if (params.conversationId) {
    searchParams.set('conversation_id', params.conversationId);
  }
  
  if (params.threadId) {
    searchParams.set('thread_id', params.threadId);
  }
  
  if (params.assistantId) {
    searchParams.set('assistant_id', params.assistantId);
  }
  
  return `${baseUrl}/gpt?${searchParams.toString()}`;
}
